import { t } from '@/i18n/utils'

/**
 * 消费记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const consumeCommonConfig = {
  texts: {
    get noRecord() { return t('NoConsumptionRecord') },
    get noMore() { return `${t('NoMore')} ~` },
    get loading() { return `${t('Loading')}...` },
    get coins() { return t('Coins') },
  },
}
